@import 'apps/webcomponents/src/assets/widget-shared.scss';
@import 'apps/webcomponents/src/assets/common.scss';
@import 'apps/webcomponents/src/assets/bb-chart.scss';

:host {
  color: var(--body-text-arrows-400);
  padding-top: calc(var(--spacer) * 1.5);
  padding-bottom: calc(var(--spacer) * 1.5);

  gz-table {
    padding: 0 calc(var(--spacer) * 3) 0 0;
  }
}

.wrapper {
  flex-direction: column;
  justify-content: space-between;

  &.is-loading {
    .content {
      display: none;
    }
  }
}

.widget-loading {
  bottom: calc(var(--spacer) * 1.5);
}

.content {
  display: flex;
  flex-direction: column;
}

.content-tables {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 100%;
}

.legend {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-top: calc(var(--spacer) * 2);

  .legend-element {
    padding-right: calc(var(--spacer) * 2);
    .label-element {
      font-size: var(--body-size);
    }
  }
}

.color-element {
  width: calc(var(--spacer) + 2px);
  height: calc(var(--spacer) + 2px);
  margin-right: var(--spacer);
  display: inline-block;
}

:host([data-display-mode='pdf']) {
  .wrapper {
    justify-content: flex-start;

    .content {
      flex: 1;
    }
    .legend {
      margin-top: auto;
    }
  }
  gz-table {
    --table-font-size: calc(var(--body-size) + 1px);

    &::part(cell-label),
    &::part(cell-value) {
      padding: calc(var(--spacer) - 3px) var(--spacer) calc(var(--spacer) - 3px) 0;
    }
  }
  .legend {
    padding-top: var(--spacer);
  }
  .legend .legend-element .label-element {
    font-size: calc(var(--body-size) - 1px);
  }
}
